import { Usuario } from './usuario';

export class Aseguradora {
    idAseguradora: number;
    nombre: string;
    descripcion: string;
    direccion: string;
    telefono1: string;
    website: string;
    contacto: string;
    email: string;
    diasCredito: number;
    contatoPago: string;
    emailPago: string;
    telefonoPago: string;
}



// WEBPACK FOOTER //
// C:/Users/stivens/Lab/sonever/repos/taller-web/src/app/core/model/classes/aseguradora.ts